/* eslint-disable no-restricted-globals */
import shared from './shared';

export default () => {
  const testimonials = document.querySelectorAll('.c-testimonials');

  if (testimonials.length < 1) {
    return;
  }

  [].forEach.call(testimonials, testimonial => {
    const slides = testimonial.querySelectorAll('.c-testimonials__item');

    if (slides.length < 2) {
      return;
    }

    const dots = testimonial.querySelectorAll('.c-testimonials__dot');
    let currentIndex = 0;

    [].forEach.call(dots, (dot, index) => {
      dot.addEventListener('click', event => {
        event.preventDefault();

        if (index === currentIndex) {
          return;
        }

        slides[currentIndex].classList.remove(shared.CSS.active);
        dots[currentIndex].classList.remove(shared.CSS.active);
        currentIndex = index;
        slides[currentIndex].classList.add(shared.CSS.active);
        dots[currentIndex].classList.add(shared.CSS.active);
      });
    });
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/testimonials.js